/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { literal } from '../../util.type';

export default {
  name: literal('asset'),
  methods: {
    toString() {
      return `Asset {id: "${this.id}", path: ${this.path}"}`;
    }
  }
};
